// *******************************************************************************
// Form : Step Form
// *******************************************************************************
const handleStepForm = async (form, formAction) => {
  const nonce = await getNonceForAction(formAction);
  const formParent = form.closest('[data-step-form-parent]');
  const allFormSteps = formParent.querySelectorAll('.step-form__step');
  const allStepIndicator = formParent.querySelectorAll('.step-form__indicator-btn');
  const nextButton = formParent.querySelector('.step-form__next-step');
  const submitButtonText = nextButton.getAttribute(['data-submit-text']);
  const nextButtonText = nextButton.querySelector('.btn__text');
  const formAlertError = formParent.querySelector('.step-form__alert-error');
  const allForms = [];
  const allStepData = [];

  let currentStepIndex = 0;

  const toggleStep = (index, active) => {
    const step = allFormSteps[index];
    const stepIndicator = allStepIndicator[index];

    FormValidation.utils.classSet(step, {
      'is-active': active,
    });
    FormValidation.utils.classSet(stepIndicator, {
      'is-active': true,
    });
  };

  const markCompleted = (index) => {
    const stepIndicator = allStepIndicator[index];
    stepIndicator.classList.add('is-completed');
  };

  const moveNextStep = async () => {
    if (currentStepIndex < allForms.length) {
      const currentForm = allForms[currentStepIndex];
      const status = await currentForm.validate();
      if (status !== 'Valid') {
        return;
      }

      let nextIndex = currentStepIndex + 1;

      while (nextIndex < allFormSteps.length && allFormSteps[nextIndex].classList.contains('hide')) {
        nextIndex += 1;
      }

      if (nextIndex < allFormSteps.length) {
        toggleStep(currentStepIndex, false);
        currentStepIndex = nextIndex;
        toggleStep(currentStepIndex, true);

        if (currentStepIndex === allFormSteps.length - 1) {
          nextButtonText.innerHTML = submitButtonText;
        }
      }
    }
  };

  allFormSteps.forEach((step, index) => {
    const fv = FormValidation.formValidation(step, {
      locale: 'sl_SI',
      localization: FormValidation.locales.sl_SI,
      fields: {
        'upload[]': {
          validators: {
            checkMaxFiles: {
              message: '',
            },
            checkFilesSize: {
              message: '',
            },
            checkFilesType: {
              message: '',
            },
          },
        },
      },
      plugins: {
        message: new FormValidation.plugins.Message({
          container: (field, element) =>
            element.closest(
              '.mod-input,.checkbox,.radio-button,.radio-button-group,.dropdown,.upload-box__main,.hidden-items',
            ),
        }),
        declarative: new FormValidation.plugins.Declarative({
          html5Input: true,
        }),
        trigger: new FormValidation.plugins.Trigger({
          event: 'submit',
        }),
        submitButton: new FormValidation.plugins.SubmitButton(),
      },
    });
    const hiddenFields = document.querySelectorAll('form input[type="hidden"]');
    hiddenFields.forEach((field) => {
      const fieldName = field.getAttribute('name');
      if (fieldName && !fv.fields[fieldName]) {
        fv.addField(fieldName, {});
      }
    });
    if (uploadBox) {
      fv.registerValidator('checkMaxFiles', fileCountValidator);
      fv.registerValidator('checkFilesSize', fileSizeValidator);
      fv.registerValidator('checkFilesType', fileTypeValidator);
    }

    fv.on('core.element.validated', (e) => {
      const value = fv.getElementValue(e.field, e.element);
      const container = FormValidation.utils.closest(
        e.element,
        '.mod-input,.checkbox,.radio-button,.radio-button-group,.dropdown,.upload-box__main',
      );
      const valueCheck = container.classList.contains('upload-box__main') ? filesToUpload.length === 0 : value === '';
      FormValidation.utils.classSet(container, {
        'is-validation-failed': valueCheck || !e.valid,
      });
    });

    if (uploadBox) {
      uploadBox.addEventListener('change', () => fv.validateField('upload[]'));
      uploadBox.addEventListener('fileRemoved', () => fv.validateField('upload[]'));
    }

    fv.on('core.form.valid', () => {
      grecaptcha.ready(async () => {
        const token = await grecaptcha.execute(localData.captchaSiteKey, { action: formAction });
        formParent.classList.add('show-loader');

        try {
          const stepData = getFormValue(step, fv);
          allStepData.push(JSON.parse(stepData.inputs));

          if (index === allFormSteps.length - 1) {
            const inputs = {};

            for (const key in allStepData) {
              if (!isNaN(key)) {
                Object.assign(inputs, allStepData[key]);
              }
            }
            if (filesToUpload) {
              Array.from(filesToUpload).forEach((file, index) => {
                inputs[`files_${index + 1}`] = file.file;
              });
            }
            const formDataInput = new FormData();
            const dropdown = form.querySelector('div.dropdown.is-selected');
            if (dropdown) {
              inputs.dropdown = dropdown.querySelector('.dropdown__placeholder-text').innerHTML;
              inputs.dropdownValue = dropdown.querySelector('.dropdown__placeholder-text').dataset.ehrm;
            }
            formDataInput.append('action', formAction);
            formDataInput.append('nonce', nonce);
            formDataInput.append('inputs', JSON.stringify(inputs));
            if (filesToUpload) {
              Array.from(filesToUpload).forEach((file, index) => {
                formDataInput.append(`files_${index + 1}`, file.file);
              });
            }
            formDataInput.append('k', form.querySelector('[data-k]').value);
            formDataInput.append('lang', localData.lang);
            formDataInput.append('id', localData.id);
            formDataInput.append('siteURL', window.location.href);
            formDataInput.append('token', token);
            const reusableModulePositionInRepeater = form.querySelector('[data-remod-repeat]');
            const reusableModulePosition = form.querySelector('[data-remod]');
            if (reusableModulePositionInRepeater) {
              formDataInput.append('remod-repeat', reusableModulePositionInRepeater.value);
            }
            if (reusableModulePosition) {
              formDataInput.append('remod', reusableModulePosition.value);
            }
            const response = await axios.post(localData.apiURL, formDataInput, {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            });
            if (response.data.data.url) {
              window.location = response.data.data.url;
            } else {
              form.classList.remove('show-loader');
              form.scrollIntoView({
                behavior: 'smooth',
              });
            }
          }
          formParent.classList.remove('show-loader');
          if (index === allFormSteps.length - 1) {
            formParent.classList.add('show-thankyou');
            if (formParent.closest('.form-modal')) {
              const formModalEle = formParent.closest('.form-modal');
              formModalEle.classList.add('show-thankyou');
            }
          } else {
            toggleStep(index, false);
            if (index + 1 < allFormSteps.length) {
              toggleStep(index + 1, true);
            }
          }
          markCompleted(index);
        } catch (error) {
          console.error(error);
          formParent.classList.remove('show-loader');
          formParent.classList.add('show-error');
          formAlertError.classList.remove('hide');
          formAlertError.innerHTML = error.response.data.data.msg;
        }
      });
    });

    allForms.push(fv);
  });

  nextButton.addEventListener('click', moveNextStep);
};

document.addEventListener('DOMContentLoaded', () => {
  ['contact-form'].forEach((id) => {
    const form = document.querySelector(`#${id}`);
    if (form !== null) {
      const formAction = form.querySelector('[data-action]').value;
      handleStepForm(form, formAction, id);
    }
  });
});

// **************************************************

const inputGroupParents = document.querySelectorAll('[data-input-group-parent]');

inputGroupParents.forEach((formRow) => {
  const inputGroups = formRow.querySelectorAll('[data-input-group-field]');
  if (inputGroups.length > 1) {
    const observer = new MutationObserver(() => {
      const radioParents = formRow.querySelectorAll('[data-input-group-item]');
      const hasFailedRadio = [...radioParents].some((radioParent) =>
        radioParent.classList.contains('is-validation-failed'),
      );
      formRow.classList.toggle('failed', hasFailedRadio);

      const groupErrorMessage = formRow.nextElementSibling;
      if (groupErrorMessage && groupErrorMessage.classList.contains('group-error')) {
        if (hasFailedRadio) {
          groupErrorMessage.classList.add('is-active');
        } else {
          groupErrorMessage.classList.remove('is-active');
        }
      }
    });

    inputGroups.forEach((item) =>
      observer.observe(item.closest('[data-input-group-item]'), { attributes: true, attributeFilter: ['class'] }),
    );

    if (formRow.classList.contains('input-group')) {
      const errorMessage = formRow.querySelector('[data-fv-not-empty___message]');
      if (errorMessage) {
        const groupErrorMessage = document.createElement('div');
        groupErrorMessage.classList.add('fv-plugins-message-container', 'group-error');
        groupErrorMessage.innerHTML = errorMessage.getAttribute('data-fv-not-empty___message');

        formRow.insertAdjacentElement('afterend', groupErrorMessage);
      }
    }
  }
});
